import InitApi from "api/InitApi";
import useTokenStore from "store/tokenStore";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import ServerErrors from "components/SeverErrors";

const useAddCourier = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();
	const addCourier = async (data) => {
		const instance = await InitApi({ accessToken });
		const res = await instance.post("users/courier", data);
		await queryClient.invalidateQueries("users");
		return res.data;
	};

	return useMutation(addCourier, {
		onSuccess: async () => {
			toast.success("Courier added successfully");
		},

		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useAddCourier;
